// pdfmake's built-in fonts (and any WinAnsi font) render a handful of common "smart" characters as
// stray glyphs — curly quotes, en/em dashes, bullets, non-breaking spaces, the multiplication sign.
// Fold everything down to plain ASCII before it reaches the document so the canonical PDF never
// shows a broken character, regardless of which font ends up rendering it.
const REPLACEMENTS: [RegExp, string][] = [
  [/[\u2018\u2019\u201A\u2032]/g, "'"],
  [/[\u201C\u201D\u201E\u2033]/g, '"'],
  [/[\u2013\u2012]/g, '-'],
  [/[\u2014]/g, '--'],
  [/[\u2022\u25CF\u25AA]/g, '-'],
  [/[\u00A0\u202F]/g, ' '],
  [/[\u00D7]/g, 'x'],
  [/[\u2026]/g, '...'],
];

export function foldToAscii(input: string | null | undefined): string {
  if (!input) return '';
  let out = input;
  for (const [pattern, replacement] of REPLACEMENTS) out = out.replace(pattern, replacement);
  return out;
}
